import React from 'react';
import type { PixInstructionsProps } from '../types/pix-payment.types';

const PixInstructions: React.FC<PixInstructionsProps> = () => {
  return (
    <div>
      <h3 className="text-xl font-semibold text-text-primary dark:text-gray-100 mb-3 self-start">
        Instruções para Pagamento:
      </h3>
      <ol className="list-decimal list-inside text-text-secondary dark:text-gray-300 space-y-2 text-left self-start">
        <li className="list-item lg:hidden">Copie o código PIX acima.</li>
        <li>Abra o aplicativo do seu banco ou instituição financeira e acesse a área PIX.</li>
        <li className="hidden lg:list-item">Escolha a opção "Pagar com QR Code" e escaneie o código acima.</li>
        <li className="list-item lg:hidden">Escolha "PIX Copia e Cola", cole o código que você copiou e prossiga.</li>
        <li>Confirme os dados e o valor do pedido.</li>
        <li>Finalize o pagamento. A aprovação geralmente ocorre em poucos minutos!</li>
      </ol>
    </div>
  );
};

export default PixInstructions; 